module.exports = __webpack_public_path__ + "media/images/ln-img2-1861b0800e5567cf39b27b2f469bd881.png";